import axios from 'axios';

// Action Types
export const FETCH_CARS_REQUEST = 'FETCH_CARS_REQUEST';
export const FETCH_CARS_SUCCESS = 'FETCH_CARS_SUCCESS';
export const FETCH_CARS_FAILURE = 'FETCH_CARS_FAILURE';
export const ADD_CAR_REQUEST = 'ADD_CAR_REQUEST';
export const ADD_CAR_SUCCESS = 'ADD_CAR_SUCCESS';
export const ADD_CAR_FAILURE = 'ADD_CAR_FAILURE';
export const UPDATE_CAR_REQUEST = 'UPDATE_CAR_REQUEST';
export const UPDATE_CAR_SUCCESS = 'UPDATE_CAR_SUCCESS';
export const UPDATE_CAR_FAILURE = 'UPDATE_CAR_FAILURE';
export const FILTER_CARS = 'FILTER_CARS';
export const PROCESS_PAYMENT_REQUEST = 'PROCESS_PAYMENT_REQUEST';
export const PROCESS_PAYMENT_SUCCESS = 'PROCESS_PAYMENT_SUCCESS';
export const PROCESS_PAYMENT_FAILURE = 'PROCESS_PAYMENT_FAILURE';
export const CLEAR_PAYMENT_STATUS = 'CLEAR_PAYMENT_STATUS';
export const FETCH_CAR_DETAILS_REQUEST = 'FETCH_CAR_DETAILS_REQUEST';
export const FETCH_CAR_DETAILS_SUCCESS = 'FETCH_CAR_DETAILS_SUCCESS';
export const FETCH_CAR_DETAILS_FAILURE = 'FETCH_CAR_DETAILS_FAILURE';


// Fetch Cars Action
export const fetchCars = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_CARS_REQUEST });
    try {
      const response = await axios.get('https://cardealer-backend-shac.onrender.com/api/cars');
      // console.log('Fetched Cars:', response.data); // Log the response data
      dispatch({ type: FETCH_CARS_SUCCESS, payload: response.data });
    } catch (error) {
      // console.error('Error fetching cars:', error); // Log the error for better visibility
      dispatch({ type: FETCH_CARS_FAILURE, payload: error.message });
    }
  };
};
// Add Car Action
export const addCar = (carData) => {
  return async (dispatch) => {
    dispatch({ type: ADD_CAR_REQUEST });
    try {
      const response = await axios.post('https://cardealer-backend-shac.onrender.com/api/cars', carData);
      dispatch({ type: ADD_CAR_SUCCESS, payload: response.data });
    } catch (error) {
      dispatch({ type: ADD_CAR_FAILURE, payload: error.message });
    }
  };
};

// Update Car Action
export const updateCar = (id, carData) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_CAR_REQUEST });
    try {
      const response = await axios.put(`https://cardealer-backend-shac.onrender.com/api/cars/${id}`, carData);
      dispatch({ type: UPDATE_CAR_SUCCESS, payload: response.data });
    } catch (error) {
      dispatch({ type: UPDATE_CAR_FAILURE, payload: error.message });
    }
  };
};

// Filter Cars Action
export const filterCars = (filters) => {
  return (dispatch, getState) => {
    const { cars } = getState().car; // Assuming you have a car reducer managing the cars list
    const filteredCars = cars.filter(car => {
      return (
        (!filters.make || car.make === filters.make) &&
        (!filters.model || car.model === filters.model) &&
        (!filters.year || car.year === filters.year) &&
        (!filters.fuelType || car.fuelType === filters.fuelType) &&
        (!filters.transmission || car.transmission === filters.transmission) &&
        (!filters.price || car.price <= filters.price)
      );
    });
    dispatch({ type: FILTER_CARS, payload: filteredCars });
  };
};

// Process Payment Action
export const processPayment = (paymentData) => {
    return async (dispatch) => {
      dispatch({ type: PROCESS_PAYMENT_REQUEST });
      try {
        // Assuming your backend endpoint is set up to handle payment processing
        const response = await axios.post('https://cardealer-backend-shac.onrender.com/api/payments', paymentData);
        dispatch({ type: PROCESS_PAYMENT_SUCCESS, payload: response.data });
      } catch (error) {
        dispatch({ type: PROCESS_PAYMENT_FAILURE, payload: error.message });
      }
    };
  };
  
  // Clear Payment Status Action
  export const clearPaymentStatus = () => {
    return {
      type: CLEAR_PAYMENT_STATUS,
    };
  };

  export const fetchCarDetails = (carId) => async (dispatch) => {
    try {
      dispatch({ type: 'FETCH_CAR_DETAILS_REQUEST' });
  
      if (!carId) {
        throw new Error("Car ID is not defined");
      }
  
      // Make sure carId is passed correctly in the URL
      const { data } = await axios.get(`https://cardealer-backend-shac.onrender.com/api/cars/${carId}`);
      console.log('Fetched Car Details from API:', data); // Debugging log to check data
  
      dispatch({
        type: 'FETCH_CAR_DETAILS_SUCCESS',
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: 'FETCH_CAR_DETAILS_FAILURE',
        payload: error.response && error.response.data.message ? error.response.data.message : error.message,
      });
    }
  };
  